import {makeAutoObservable} from 'mobx';
import {Role} from "src/app/constant/Enums";
import {SessionContext} from "src/app/util/SessionParamUtil";

/**
 * Holds the Case Audit (Management) page session context supplied by MCExecute
 * through the iFrame URL params (alias, role, bu). Hydrated once on app mount.
 *
 * NOTE: uses `makeAutoObservable` WITHOUT decorators — in MobX 6 the two must not be
 * mixed (decorators require `makeObservable`; `makeAutoObservable` infers annotations
 * itself). See https://mobx.js.org/observable-state.html#makeautoobservable
 */
class SessionStore {
    alias = '';
    role: Role = Role.UNKNOWN;
    bu = '';

    constructor() {
        makeAutoObservable(this);
    }

    hydrate(context: SessionContext) {
        this.alias = context.alias;
        this.role = context.role;
        this.bu = context.bu;
    }

    reset() {
        this.alias = '';
        this.role = Role.UNKNOWN;
        this.bu = '';
    }
}

export default new SessionStore();
